/** ---------------------------------------------------------------------------------------
 * --  LICENSE AGREEMENT -- *
 This software is licensed under the following terms:

 * -- GRANT OF LICENSE | RESTRICTIONS -- *
 Subject to the terms and conditions of this license, the copyright holders
 hereby grant you a non-exclusive, non-transferable, revocable license to use,
 copy, modify, and distribute the software.
 You are expressly prohibited from selling or commercially exploiting the software.
 Unauthorized use, reproduction, or distribution of the software, or any part
 thereof, is strictly prohibited.

 * -- AUTHORIZED USERS | INTELLECTUAL PROPERTY -- *
 This license is granted only to the individual or entity to whom the software is
 directly distributed by the copyright holders. Any use by other individuals or
 entities is unauthorized and in violation of this license. The software is
 protected by copyright and other intellectual property laws.
 The copyright holders retain all rights, title, and interest in the software.

 * -- GOVERNING LAW -- *
 This license is governed by and construed in accordance with the laws of Romania.
 Any legal action or proceeding related to this license shall be brought exclusively
 in the courts of Romania.

 [Weddify x Diaphan Stationery] © [2024] All rights reserved.
 -------------------------------------------------------------------------------------- **/

import clsx from 'clsx';
import React from 'react';
import { UseFormRegisterReturn } from 'react-hook-form';
import { AppFieldWrapper, FieldWrapperPassThroughProps } from './AppFieldWrapper';

type TextAreaFieldProps = FieldWrapperPassThroughProps & {
    className?: string;
    registration: Partial<UseFormRegisterReturn>;
    rows?: number;
    label: string;
    tooltip?: any
};

export const AppTextarea = (props: TextAreaFieldProps) => {
    const { label, className, registration, rows, error } = props;
    return (
        <AppFieldWrapper error={error}>
      <textarea
          placeholder={label}
          className={clsx(
              'mt-4 flex w-full items-center justify-center rounded-sm border border-black bg-white/30 p-3 text-base outline-hidden dark:text-mono-0 dark:border-mono-0 dark:bg-mono-600',
              className
          )}
          rows={rows}
          {...registration}
      />
        </AppFieldWrapper>
    );
};
